module.exports = __webpack_public_path__ + "static/img/about-background.400617d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/main/about-background.png
// module id = VuRh
// module chunks = 1